import { render } from "./ServicesSection.vue?vue&type=template&id=cb7ae27e&scoped=true"
const script = {}

import "./ServicesSection.vue?vue&type=style&index=0&id=cb7ae27e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb7ae27e"]])

export default __exports__